import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import { ReactComponent as Cash } from "../../CheckoutProcess/assets/money.svg";
import { ReactComponent as Credit } from "../../CheckoutProcess/assets/credit.svg";
import { ReactComponent as Debit } from "../../CheckoutProcess/assets/debit.svg";
import { ReactComponent as Bookeey } from "../../CheckoutProcess/assets/bookeey.svg";
import { ReactComponent as OnCredit } from "../../CheckoutProcess/assets/on-credit.svg";
import { ReactComponent as POS } from "../../CheckoutProcess/assets/pos.svg";
import BenefitGateway from "../../CheckoutProcess/assets/benefit-gateway.png";
import { connect } from "react-redux";
import FormHelperText from "@material-ui/core/FormHelperText";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DownloadQuotation from "./DownloadQuotation";
import { MenuList } from "@material-ui/core";
import { CheckCircleOutline, RadioButtonUnchecked } from "@material-ui/icons";
import Checkbox from "@material-ui/core/Checkbox";

class PaymentMethod extends Component {
  render() {
    const { language, settings, distributor, themeColor } = this.props;

    const shouldEnableCash = () => {
      if (!distributor.enable_cash_payments) return false;
      return true;
    };

    const debitCardText =
      language == "english"
        ? settings.custom_texts.debit_card
        : settings.custom_texts.debit_card_ar;
    const creditCardText =
      language == "english"
        ? settings.custom_texts.credit_card
        : settings.custom_texts.credit_card_ar;
    const debitCreditText =
      language == "english"
        ? `${settings.custom_texts.debit_card}/${settings.custom_texts.credit_card}`
        : `${settings.custom_texts.credit_card_ar}/${settings.custom_texts.debit_card_ar}`;

    const cashText =
      language === "english"
        ? settings.custom_texts.cash
        : settings.custom_texts.cash_ar;
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "english" ? "Payment Method" : "طريقة الدفع"}
        </p>

        <div
          className="border-top border-bottom w-100 mx-0 mb-3"
          style={{ backgroundColor: "white" }}
        >
          <MenuList labelId="demo-simple-select-label" id="demo-simple-select">
            {shouldEnableCash() && (
              <MenuItem
                onClick={() => this.props.handleChange("cash")}
                value="cash"
                dir={language == "english" ? "ltr" : "rtl"}
              >
                <Checkbox
                  inputProps={{ "aria-label": "primary checkbox" }}
                  icon={<RadioButtonUnchecked />}
                  checkedIcon={
                    <CheckCircleOutline style={{ color: themeColor }} />
                  }
                  checked={this.props.value === "cash"}
                  color="primary"
                />
                <span
                  className={
                    language == "english" ? "float-left pl-2" : "float-right"
                  }
                  style={{ lineHeight: 2, verticalAlign: "middle" }}
                >
                  {cashText}
                </span>
                <span
                  className={
                    language == "english"
                      ? "ml-auto float-right"
                      : "mr-auto float-left pl-2"
                  }
                >
                  <Cash width="30" height="30" />
                </span>
              </MenuItem>
            )}

            {distributor.enable_on_credit_payments &&
              settings.enable_b2b_on_credit_payments && (
                <MenuItem
                  onClick={() => this.props.handleChange("on-credit")}
                  value="on-credit"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "on-credit"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {language == "english" ? "On Credit" : "على الحساب"}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto float-left pl-2"
                    }
                  >
                    <OnCredit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_tap && (
                <MenuItem
                  onClick={() => this.props.handleChange("tap")}
                  value="tap"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "tap"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_tap_v2 && (
                <MenuItem
                  onClick={() => this.props.handleChange("tap_v2")}
                  value="tap_v2"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "tap_v2"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_tap_v3_debit && (
                <MenuItem
                  onClick={() => this.props.handleChange("tap_v2")}
                  value="tap_v2"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "tap_v2"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_hesabe && (
                <MenuItem
                  onClick={() => this.props.handleChange("hesabe")}
                  value="hesabe"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "hesabe"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_myfatoorah && (
                <MenuItem
                  onClick={() => this.props.handleChange("myfatoorah")}
                  value="myfatoorah"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "myfatoorah"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_bookey && (
                <MenuItem
                  onClick={() => this.props.handleChange("bookey")}
                  value="bookey"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "bookey"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_tahseeel && (
                <MenuItem
                  onClick={() => this.props.handleChange("tahseeel")}
                  value="tahseeel"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "tahseeel"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_ebutler_payment && (
                <MenuItem
                  onClick={() => this.props.handleChange("ebutler")}
                  value="ebutler"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "ebutler"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_gatee && (
                <MenuItem
                  onClick={() => this.props.handleChange("gatee")}
                  value="gatee"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "gatee"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_sadad && (
                <MenuItem
                  onClick={() => this.props.handleChange("sadad")}
                  value="sadad"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "sadad"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_sadad_kw && (
                <MenuItem
                  onClick={() => this.props.handleChange("sadad_kw")}
                  value="sadad_kw"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "sadad_kw"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCreditText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_tpay && (
                <MenuItem
                  onClick={() => this.props.handleChange("tpay")}
                  value="tpay"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "tpay"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_knet && (
                <MenuItem
                  onClick={() => this.props.handleChange("knet")}
                  value="knet"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "knet"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_benefit && (
                <MenuItem
                  onClick={() => this.props.handleChange("benefit")}
                  value="benefit"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "benefit"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <img src={BenefitGateway} width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_ottu && (
                <MenuItem
                  onClick={() => this.props.handleChange("ottu")}
                  value="ottu"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "ottu"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_ottu &&
              settings.enable_ottu_credit && (
                <MenuItem
                  onClick={() => this.props.handleChange("ottu-cc")}
                  value="ottu-cc"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "ottu-cc"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_ottu_v2 && (
                <MenuItem
                  onClick={() => this.props.handleChange("ottu_v2")}
                  value="ottu_v2"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "ottu_v2"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_credimax && (
                <MenuItem
                  onClick={() => this.props.handleChange("credimax")}
                  value="credimax"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "credimax"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_eazypay && (
                <MenuItem
                  onClick={() => this.props.handleChange("eazypay")}
                  value="eazypay"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "eazypay"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_ap_gateway && (
                <MenuItem
                  onClick={() => this.props.handleChange("apgateway")}
                  value="apgateway"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "apgateway"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_nbk && (
                <MenuItem
                  onClick={() => this.props.handleChange("nbk")}
                  value="nbk"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "nbk"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_upay && (
                <MenuItem
                  onClick={() => this.props.handleChange("upay")}
                  value="upay"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "upay"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}

            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_upay_v2 && (
                <MenuItem
                  onClick={() => this.props.handleChange("upay_v2")}
                  value="upay_v2"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "upay_v2"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {debitCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Debit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {/* {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_upay && (
                <MenuItem
                  value="upay-cc"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )} */}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_bookey &&
              settings.enable_bookey_credit && (
                <MenuItem
                  onClick={() => this.props.handleChange("bookey-cc")}
                  value="bookey-cc"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "bookey-cc"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {creditCardText}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Credit width="30" height="30" />
                  </span>
                </MenuItem>
              )}
            {distributor.enable_online_payments &&
              settings.enable_payments &&
              settings.enable_bookey && (
                <MenuItem
                  onClick={() => this.props.handleChange("bookey-wallet")}
                  value="bookey-wallet"
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    icon={<RadioButtonUnchecked />}
                    checkedIcon={
                      <CheckCircleOutline style={{ color: themeColor }} />
                    }
                    checked={this.props.value === "bookey-wallet"}
                    color="primary"
                  />
                  <span
                    className={
                      language == "english" ? "float-left pl-2" : "float-right"
                    }
                    style={{ lineHeight: 2, verticalAlign: "middle" }}
                  >
                    {language == "english" ? "Bookeey Wallet" : "محفظة بوكي"}
                  </span>
                  <span
                    className={
                      language == "english"
                        ? "ml-auto float-right"
                        : "mr-auto pl-2 float-left"
                    }
                  >
                    <Bookeey width="30" height="30" />
                  </span>
                </MenuItem>
              )}
          </MenuList>
          <FormHelperText
            error={this.props.paymentError}
            className={"mx-auto ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={{
              width: "92%",
              display: this.props.paymentError == false && "none",
            }}
          >
            {language == "english"
              ? "Please select a payment method"
              : "الرجاء اختيار طريقة الدفع"}
          </FormHelperText>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    address: state.customers.address,
    countries: state.store.store.all_countries || state.store.store.countries,
    branch: state.branch,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branches: state.store.store.branches,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

export default connect(mapStateToProps)(PaymentMethod);
